import thumbnail from './piechart_thumb.svg';

export const metadata = {
  name: 'global.section.chartselection.piechart.title',
  id: 'piechart',
  thumbnail,
  icon: 'fa-chart-pie',
  categories: ['categories.proportions'],
  description: 'global.section.chartselection.piechart.description',
  code: '',
  tutorial: '',
};
